module.exports = __webpack_public_path__ + "static/media/view.c6c70d5a.svg";